/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Total_EventsInputs */

const en_explorer_info_property_total_events = /** @type {(inputs: Explorer_Info_Property_Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Events`)
};

const fr_explorer_info_property_total_events = /** @type {(inputs: Explorer_Info_Property_Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des evenements`)
};

const de_explorer_info_property_total_events = /** @type {(inputs: Explorer_Info_Property_Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtereignisse`)
};

const it_explorer_info_property_total_events = /** @type {(inputs: Explorer_Info_Property_Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi totali`)
};

const ru_explorer_info_property_total_events = /** @type {(inputs: Explorer_Info_Property_Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего событий`)
};

const es_explorer_info_property_total_events = /** @type {(inputs: Explorer_Info_Property_Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de eventos`)
};

const zh_cn2_explorer_info_property_total_events = /** @type {(inputs: Explorer_Info_Property_Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总事件`)
};

const ja_explorer_info_property_total_events = /** @type {(inputs: Explorer_Info_Property_Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計イベント数`)
};

const hi_explorer_info_property_total_events = /** @type {(inputs: Explorer_Info_Property_Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल घटनाएँ`)
};

const pt_pt2_explorer_info_property_total_events = /** @type {(inputs: Explorer_Info_Property_Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de eventos`)
};

/**
* | output |
* | --- |
* | "Total Events" |
*
* @param {Explorer_Info_Property_Total_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_total_events = /** @type {((inputs?: Explorer_Info_Property_Total_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Total_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_total_events(inputs)
	if (locale === "de") return de_explorer_info_property_total_events(inputs)
	if (locale === "it") return it_explorer_info_property_total_events(inputs)
	if (locale === "ru") return ru_explorer_info_property_total_events(inputs)
	if (locale === "es") return es_explorer_info_property_total_events(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_total_events(inputs)
	if (locale === "ja") return ja_explorer_info_property_total_events(inputs)
	if (locale === "hi") return hi_explorer_info_property_total_events(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_total_events(inputs)
	return en_explorer_info_property_total_events(inputs)
});